export const sitecorePublicEndpoints = {
	documentCenter: "/investment-api/v2/document-grid",
};

export const externalEndpoints = {
	googleGeo: "https://maps.googleapis.com/maps/api/geocode/json",
};
export const token = {
	googleGeoApiKey: "AIzaSyD2lWe6mIGLyA0EWKAg_iJTbvc7-5ju_A4",
};

export const searchEndpoints = {
	liteShare: "/xlink-api/generate-modal?id=",
};

export default {
	externalEndpoints,
	token,
	searchEndpoints,
};
